import { ROUTES } from 'src/enums';

export default [
  {
    path: '/social',
    meta: { auth: true, social: true },
    component: () => import('layouts/SpaLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('layouts/SocialLayout.vue'),
        children: [
          {
            path: '',
            name: ROUTES.SOCIAL.INDEX,
            component: () => import('pages/planner/CalendarPage.vue'),
          },
          {
            path: 'post/:channelGuid?/:postGuid?',
            name: ROUTES.SOCIAL.POST,
            component: () => import('pages/planner/PostPage.vue'),
          },
          {
            path: 'manage-channels/:query?',
            name: ROUTES.SOCIAL.CHANNELS,
            component: () => import('pages/planner/ChannelsPage.vue'),
          },
          {
            path: 'social-media-planner/manage-channels/:query?',
            name: ROUTES.SOCIAL.CHANNELS_AUTH,
            component: () => import('pages/planner/ChannelsPage.vue'),
          },
          {
            path: 'planned',
            name: ROUTES.SOCIAL.PLANNED,
            component: () => import('pages/planner/PlannedPage.vue'),
          },
          {
            path: 'brand-voice',
            name: ROUTES.SOCIAL.BRAND_VOICE,
            component: () => import('pages/BrandVoicePage.vue'),
          },
        ],
      },
    ],
  },
];
